<template functional>
    <button
        :class="['m-tile tile', props.item.cssClass]"
        type="button"
        @click="listeners.click(props.item)"
    >
        <div class="tile-header">
            <div class="tile-logo">
                <img
                    v-if="props.item.files.icon"
                    alt=""
                    :src="props.item.files.icon"
                    class="tile-icon"
                >
            </div>
            <div class="tile-title">
                {{ props.item.name }}
            </div>
        </div>
        <div class="tile-footer">
            <slot />
        </div>
    </button>
</template>

<script>
export default {
    name: "MTile",
    props: {
        item: {
            type: Object,
            required: true
        }
    },
}
</script>

<style lang="scss">
@import "theme";
</style>
